export default __webpack_public_path__ + "static/media/h2a4.7f9effb3.jpg";